import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M5 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2m11.71-6.71-7-7C9.51.1 9.26 0 9 0s-.51.1-.71.29l-8 8C.11 8.48 0 8.73 0 9v7c0 .55.45 1 1 1h7c.27 0 .52-.11.71-.29l8-8c.39-.39.39-1.03 0-1.42",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }